import * as React from 'react';
import Button from 'react-bootstrap/Button';
import classnames from 'classnames';

import './style.scss';

interface IButtonProps {
  content?: any;
  onClick?: TButtonOnClick;
  bsStyle?: ButtonStyle;
  className?: string;
  disabled?: boolean;
  onFocus?: (event: any) => void;
  id?: string;
  bgColor?: string;
  color?: string;
  displayOverflow?: boolean;
  showLoader?: boolean;
  'aria-label'?: string;
  'aria-pressed'?: boolean | 'true' | 'false' | 'mixed';
}

interface IButtonState {
  disabled: boolean;
}

export default class SquareButton extends React.Component<IButtonProps, IButtonState> {
  private _isMounted: boolean = false;

  constructor(props: IButtonProps) {
    super(props);

    this.state = {
      disabled: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleClick = (e?: React.SyntheticEvent<any>) => {
    // Only proceed if onClick exists
    if (!this.props.onClick) return;

    const handler = this.props.onClick(e);

    // Check if handler is Promise-like before using .then/.catch
    if (handler && typeof handler.then === 'function') {
      if (this._isMounted) {
        this.setState({ disabled: true });
      }

      handler
        .then(() => {
          if (this._isMounted) {
            this.setState({ disabled: false });
          }
        })
        .catch((error) => {
          console.error('Button click handler error:', {
            error,
            errorMessage: error.message,
            errorStack: error.stack,
            componentId: this.props.id,
            componentProps: this.props,
          });
          if (this._isMounted) {
            this.setState({ disabled: false });
          }
        });
    }
  };

  render() {
    // eslint-disable-next-line react/prop-types
    const { content, className, bsStyle, disabled, children, bgColor, color, displayOverflow, showLoader, 'aria-label': ariaLabel, 'aria-pressed': ariaPressed } = this.props;

    const inlineStyles: React.CSSProperties = {};
    if (bgColor) {
      inlineStyles.backgroundColor = bgColor;
    }
    if (color) {
      inlineStyles.color = color;
    }
    if (displayOverflow) {
      inlineStyles.overflow = 'visible';
    }

    return (
      <Button
        onClick={this.handleClick}
        variant={bsStyle}
        style={inlineStyles}
        className={classnames('square-btn', `${className || ''}`, {
          'show-loader': this.state.disabled || showLoader,
        })}
        disabled={disabled || this.state.disabled}
        onFocus={this.props.onFocus}
        id={this.props.id}
        aria-label={ariaLabel}
        aria-pressed={ariaPressed}
      >
        {content || children}
      </Button>
    );
  }
}
